import { TEXTS } from 'application/pages/texts';

import { DeviceTypes } from 'domain/api/graphql/generated';

import { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';

export const getStreamDescription = (streamTitle?: string) => {
  const title = streamTitle || TEXTS.MODAL_BIND_STREAM_NOT_BIND;

  return `${TEXTS.MODAL_BIND_STREAM_BIND}: ${title}`;
};

export const getPlayerDescription = (deviceType?: DeviceTypes) => {
  if (!deviceType) {
    return TEXTS.MODAL_BIND_NO_DEVICE;
  }

  if (deviceType === DeviceTypes.Webplayer) {
    return TEXTS.MODAL_BIND_WEB_PLAYER;
  }

  return TEXTS.MODAL_BIND_PLAYER_APPLICATION;
};

export const getPopperPlacement = (isDesktop: boolean, hintIconNearSelector: boolean) => {
  if (hintIconNearSelector) {
    return HintPlacement.PLACEMENT_RIGHT;
  }

  if (isDesktop) {
    return HintPlacement.PLACEMENT_RIGHT_END;
  }

  return HintPlacement.PLACEMENT_BOTTOM;
};
